export const languagesList = {
  language: [
    { id: 1, label: 'Afrikaans - Afrikaans', value: 'Afrikaans', code: 'af' },
    { id: 62, label: 'አማርኛ - Amharic', value: 'Amharic', code: 'am' },
    { id: 2, label: 'العربية - Arabic', value: 'Arabic', code: 'ar' },
    { id: 3, label: 'Հայերեն - Armenian', value: 'Armenian', code: 'hy' },
    { id: 4, label: 'Azərbaycanca - Azerbaijani', value: 'Azerbaijani', code: 'az' },
    { id: 5, label: 'Беларуская - Belarusian', value: 'Belarusian', code: 'be' },
    { id: 6, label: 'বাংলা - Bengali', value: 'Bengali', code: 'bn' },
    { id: 7, label: 'Bosanski - Bosnian', value: 'Bosnian', code: 'bs' },
    { id: 8, label: 'Български - Bulgarian', value: 'Bulgarian', code: 'bg' },
    { id: 9, label: '廣東話 - Cantonese', value: 'Cantonese', code: 'yue' },
    { id: 10, label: 'Català - Catalan', value: 'Catalan', code: 'ca' },
    { id: 11, label: '简体中文 - Chinese', value: 'Chinese', code: 'zh' },
    {
      id: 64,
      label: '繁體中文 - Chinese (Traditional)',
      value: 'Chinese (Traditional)',
      code: 'zh-TW',
    },
    { id: 12, label: 'Hrvatski - Croatian', value: 'Croatian', code: 'hr' },
    { id: 13, label: 'Čeština - Czech', value: 'Czech', code: 'cs' },
    { id: 14, label: 'Dansk - Danish', value: 'Danish', code: 'da' },
    { id: 15, label: 'Nederlands - Dutch', value: 'Dutch', code: 'nl' },
    { id: 16, label: 'English - English', value: 'English', code: 'en' },
    { id: 17, label: 'Eesti - Estonian', value: 'Estonian', code: 'et' },
    { id: 18, label: 'Suomi - Finnish', value: 'Finnish', code: 'fi' },
    { id: 19, label: 'Français - French', value: 'French', code: 'fr' },
    { id: 20, label: 'Galego - Galician', value: 'Galician', code: 'gl' },
    { id: 63, label: 'ქართული - Georgian', value: 'Georgian', code: 'ka' },
    { id: 21, label: 'Deutsch - German', value: 'German', code: 'de' },
    { id: 22, label: 'Ελληνικά - Greek', value: 'Greek', code: 'el' },
    { id: 23, label: 'עברית - Hebrew', value: 'Hebrew', code: 'iw' },
    { id: 24, label: 'हिन्दी - Hindi', value: 'Hindi', code: 'hi' },
    { id: 25, label: 'Magyar - Hungarian', value: 'Hungarian', code: 'hu' },
    { id: 26, label: 'Íslenska - Icelandic', value: 'Icelandic', code: 'is' },
    { id: 27, label: 'Italiano - Italian', value: 'Italian', code: 'it' },
    { id: 28, label: '日本語 - Japanese', value: 'Japanese', code: 'ja' },
    { id: 29, label: 'ಕನ್ನಡ - Kannada', value: 'Kannada', code: 'kn' },
    { id: 30, label: 'Қазақ - Kazakh', value: 'Kazakh', code: 'kk' },
    { id: 31, label: '한국어 - Korean', value: 'Korean', code: 'ko' },
    { id: 32, label: 'Македонски - Macedonian', value: 'Macedonian', code: 'mk' },
    { id: 33, label: 'Bahasa Melayu - Malay', value: 'Malay', code: 'ms' },
    { id: 34, label: 'Māori - Maori', value: 'Maori', code: 'mi' },
    { id: 35, label: 'मराठी - Marathi', value: 'Marathi', code: 'mr' },
    { id: 36, label: 'ਪੰਜਾਬੀ - Punjabi', value: 'Punjabi', code: 'pa' },
    { id: 37, label: 'فارسی - Persian', value: 'Persian', code: 'fa' },
    { id: 38, label: 'Polski - Polish', value: 'Polish', code: 'pl' },
    { id: 39, label: 'Português - Portuguese', value: 'Portuguese', code: 'pt' },
    { id: 40, label: 'Română - Romanian', value: 'Romanian', code: 'ro' },
    { id: 41, label: 'Русский - Russian', value: 'Russian', code: 'ru' },
    { id: 42, label: 'Српски - Serbian', value: 'Serbian', code: 'sr' },
    { id: 43, label: 'Slovenčina - Slovak', value: 'Slovak', code: 'sk' },
    { id: 44, label: 'Slovenščina - Slovenian', value: 'Slovenian', code: 'sl' },
    { id: 45, label: 'Español - Spanish', value: 'Spanish', code: 'es' },
    { id: 46, label: 'Kiswahili - Swahili', value: 'Swahili', code: 'sw' },
    { id: 47, label: 'Svenska - Swedish', value: 'Swedish', code: 'sv' },
    { id: 48, label: 'தமிழ் - Tamil', value: 'Tamil', code: 'ta' },
    { id: 65, label: 'తెలుగు - Telugu', value: 'Telugu', code: 'te' },
    { id: 49, label: 'ไทย - Thai', value: 'Thai', code: 'th' },
    { id: 50, label: 'Türkçe - Turkish', value: 'Turkish', code: 'tr' },
    { id: 51, label: 'Українська - Ukrainian', value: 'Ukrainian', code: 'uk' },
    { id: 52, label: 'اردو - Urdu', value: 'Urdu', code: 'ur' },
    { id: 53, label: 'Tiếng Việt - Vietnamese', value: 'Vietnamese', code: 'vi' },
    { id: 54, label: 'Cymraeg - Welsh', value: 'Welsh', code: 'cy' },
    { id: 55, label: 'Bahasa Indonesia - Indonesian', value: 'Indonesian', code: 'id' },
    { id: 56, label: 'Latviski - Latvian', value: 'Latvian', code: 'lv' },
    { id: 57, label: 'Lietuvių - Lithuanian', value: 'Lithuanian', code: 'lt' },
    { id: 58, label: 'नेपाली - Nepali', value: 'Nepali', code: 'ne' },
    { id: 59, label: 'Norsk - Norwegian', value: 'Norwegian', code: 'no' },
    { id: 60, label: 'Tagalog - Tagalog', value: 'Tagalog', code: 'tl' },
    { id: 61, label: "O'zbek - Uzbek", value: 'Uzbek', code: 'uz' },
  ],
};

languagesList.language.sort((a, b) => a.value.localeCompare(b.value));
